module.exports = __webpack_public_path__ + "static/logo-cf32061af4d3b14cd237d0328d0ae30c.png";